import axios, { AxiosResponse } from 'axios'

import { useAPIDest, useAPIOptions } from './useAPI.types'

export const gambitDefaultAPIOptions = {
  headers: {
    'X-Forward-User-Agent': 'mission-control',
  },
}

export const defaultAPIOptions: useAPIOptions<{}> = {
  params: {},
  data: {},
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  },
}

export function createAPIOptions<ReactQueryOptions>(
  apiOptions?: useAPIOptions<ReactQueryOptions>,
  user?: { auth_token?: string } | null,
) {
  const optionsWithDefaults = {
    ...defaultAPIOptions,
    ...apiOptions,
    headers: { ...defaultAPIOptions.headers, ...apiOptions?.headers },
  }

  const headers = {
    ...(user?.auth_token && { 'x-api-token': user.auth_token }),
    ...optionsWithDefaults.headers,
  }

  const params = {
    ...optionsWithDefaults.params,
  }

  return {
    ...optionsWithDefaults,
    headers,
    params,
  } as useAPIOptions<ReactQueryOptions>
}

export function createAPIQueryFunction(
  dest: useAPIDest,
  apiOptions: useAPIOptions,
  handleResponse?: (res: AxiosResponse) => any,
) {
  return async function queryFn(queryData?: any) {
    const apiDest = typeof dest === 'function' ? dest(queryData.data) : dest
    const { url, method } = apiDest
    const { headers, data } = apiOptions
    const params = {
      ...apiOptions.params,
      ...apiOptions.nonKeyParams,
    }

    const isGET = method?.toLowerCase() === 'get'

    const res = await axios.request({
      url,
      method,
      headers,
      params,
      // * useAPIMutation data comes from queryFn param,
      data: isGET ? data : typeof dest === 'function' ? queryData.body : queryData,
    })

    return handleResponse ? handleResponse(res) : res.data
  }
}

export function createAPIQueryKey(dest: useAPIDest, params?: Object) {
  const apiDest = typeof dest === 'function' ? dest() : dest
  return [apiDest.url, apiDest.method, ...(params ? [params] : [])]
}
